import React, { useEffect, useState } from 'react';
import { AdminSidebar } from './AdminDashboardPage';
import {
  getCategories,
  createCategory,
  deleteCategory
} from '../../services/categoryService';
import '../../css/adminDashboard.css';

const AdminCategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategorySlug, setNewCategorySlug] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const data = await getCategories();
      setCategories(data);
    } catch (err) {
      console.error('Failed to load categories:', err);
    }
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCategoryName.trim() || !newCategorySlug.trim()) {
      setError('Name and Slug are required');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await createCategory({
        name: newCategoryName,
        slug: newCategorySlug.toLowerCase().replace(/\s+/g, '-'),
        description: 'Menswear essentials'
      });
      setNewCategoryName('');
      setNewCategorySlug('');
      loadCategories();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create category');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCategory = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) {
      return;
    }

    try {
      await deleteCategory(id);
      loadCategories();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to delete category');
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <h1>Categories</h1>

        {/* Add Category Form */}
        <div className="admin-card" style={{ maxWidth: '500px', marginBottom: '2rem' }}>
          <h3>Add New Category</h3>
          <form onSubmit={handleAddCategory}>
            <div className="form-row">
              <label>Category Name</label>
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="e.g., TopWear"
                required
              />
            </div>
            <div className="form-row">
              <label>Slug (URL-friendly)</label>
              <input
                type="text"
                value={newCategorySlug}
                onChange={(e) => setNewCategorySlug(e.target.value)}
                placeholder="e.g., topwear"
                required
              />
            </div>
            {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Adding...' : 'Add Category'}
            </button>
          </form>
        </div>

        {/* Categories List */}
        <div className="admin-card">
          <h3>Existing Categories</h3>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr key={category._id}>
                  <td>{category.name}</td>
                  <td>{category.slug}</td>
                  <td>
                    <button
                      className="btn-danger"
                      onClick={() => handleDeleteCategory(category._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {categories.length === 0 && (
            <p style={{ padding: '1rem', textAlign: 'center' }}>No categories found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCategoriesPage;
